import React, { useContext } from "react";
import { Card, CardContent, CardHeader } from "../../ui/card";
import { Button } from "../../ui/button";
import { Archive, Eye, Flag } from "lucide-react";
import AuthContext from "../../../hooks/authContext";
import { Badge } from "../../ui/badge";
import { getFormatedTime } from "../../../services/helpers";

const IssuePriorityBadge = ({ priority }) => {
  const getBadgeStyles = () => {
    switch (priority) {
      case "High":
        return "bg-red-100 text-red-800 hover:bg-red-100";
      case "urgent":
        return "bg-orange-100 text-orange-800 hover:bg-orange-100";
      case "Medium":
        return "bg-yellow-100 text-yellow-800 hover:bg-yellow-100";
      case "Low":
        return "bg-green-100 text-green-800 hover:bg-green-100";
      default:
        return "bg-gray-100 text-gray-800 hover:bg-gray-100";
    }
  };

  return (
    <Badge className={`font-medium ${getBadgeStyles()}`} variant="outline">
      {priority?.charAt(0).toUpperCase() + priority?.slice(1)}
    </Badge>
  );
};

const IssueCommonCard = ({
  index,
  record,
  redirectToDetails,
  issue,
  handelUnArchive,
  settingsData,
}) => {
  const timeZone = record?.timeZone ? record?.timeZone : "America/New_York";
  const auth = useContext(AuthContext);
  let boldclasss = record?.readUser ? !record?.readUser?.includes(auth?.userProfile?.id) : false;
const role = auth?.userProfile?.role;
const companyUser = role === "companyUser";
const allowedRoles = settingsData?.archiveRequestRole;
const normalizedRole = Array.isArray(role) ? role : [role];
const hasAccess = normalizedRole.some(r => allowedRoles.includes(r));
const canArchive = companyUser || !settingsData ||  hasAccess;

  return (
    <Card className="overflow-hidden mb-15 dark:bg-[#1A1F2C] shadow-md dark:shadow-[0_0_12px_rgba(2,8,23,0.8)]">
      <CardHeader className="bg-slate-50 dark:bg-[#1A1F2C] py-3 px-4">
        <div className="flex justify-between items-center">
          <div className="flex items-center gap-2">
            {boldclasss === true && (
              <Flag className="h-4 w-4 text-red-500 fill-red-500" />
            )}
            <span className="font-medium text-sm color-newBlack dark:text-white">
              {record?.isuueId}
            </span>
          </div>
          <IssuePriorityBadge priority={record?.priority} />
        </div>
      </CardHeader>
      <CardContent className="p-16 bg-white dark:bg-[#1A1F2C]">
        <div className="mb-12">
          <div className="text-sm text-gray-700 line-clamp-2 mb-8 dark:text-[#6B7280]">
            {record?.description}
          </div>
          <div className="grid grid-cols-2 gap-x-4 gap-y-2 text-sm">
            <div className="flex flex-col">
              <span className="text-gray-500">Client</span>
              <span className="font-medium color-newBlack dark:text-white">
                {record?.clientName}
              </span>
            </div>
            <div className="flex flex-col">
              <span className="text-gray-500">Raised by</span>
              <span className="font-medium color-newBlack dark:text-white">
                {record?.createdUser}
              </span>
            </div>
            <div className="flex flex-col">
              <span className="text-gray-500">Updated</span>
              <span className="font-medium color-newBlack dark:text-white">
                {getFormatedTime(record?.updatedAt, timeZone)}
              </span>
            </div>
          </div>
        </div>

        <div className="flex justify-end gap-2 mt-16">
          <Button
            variant="outline"
            size="sm"
            className="text-purple-600 border-purple-200 hover:bg-purple-50 hover:text-purple-700"
            onClick={() => redirectToDetails(record?.id)}
          >
            <Eye size={16} className="mr-1" /> View
          </Button>

          {issue === true ? (
           <Button
              variant="outline"
              size="sm"
              disabled={!canArchive}
              className={`text-amber-600 border-amber-200 hover:bg-amber-50 hover:text-amber-700 ${
                !canArchive ? "opacity-50 cursor-not-allowed" : ""
              }`}
              onClick={() => {
                if (canArchive) {
                  handelUnArchive(record);
                }
              }}
            >
              <Archive size={16} className="mr-4" />
              Archive
            </Button>
          ) : (
            <Button
              variant="outline"
              size="sm"
              className={
                "text-blue-600 border-blue-200 hover:bg-blue-50 hover:text-blue-700"
              }
              onClick={() => handelUnArchive(record)}
              disabled={
                settingsData
                  ? auth?.userProfile?.role !== "companyUser" &&
                    !settingsData.archiveRequestRole?.some((r) => Array.isArray(auth?.userProfile?.role) ? auth.userProfile.role.includes(r) : auth.userProfile.role === r)
                  : false
              }
            >
              <Archive size={16} className="mr-4" />
              {"UnArchive"}
            </Button>
          )}
        </div>
      </CardContent>
    </Card>
  );
};

export default IssueCommonCard;